var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "min-width": "200" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              !_vm.activator
                ? _c("v-icon", _vm._g({}, on), [_vm._v("keyboard_arrow_down")])
                : _c(
                    "v-btn",
                    _vm._g({ attrs: { fab: "", small: "" } }, on),
                    [
                      _c("v-avatar", { attrs: { size: "40px" } }, [
                        _c("img", { attrs: { src: _vm.activator } })
                      ])
                    ],
                    1
                  )
            ]
          }
        }
      ])
    },
    [_vm._v(" "), _vm._t("dropdown")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75cbb94b", { render: render, staticRenderFns: staticRenderFns })
  }
}